'use strict';

var _objectSpread = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/objectSpread2");

var _regeneratorRuntime = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _classCallCheck = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _inherits = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var _createSuper = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createSuper");

var _require = require('./utils'),
    io = _require.io;

var AccessController = require('./access-controller-interface');

var type = 'ipfs';

var IPFSAccessController = /*#__PURE__*/function (_AccessController) {
  _inherits(IPFSAccessController, _AccessController);

  var _super = _createSuper(IPFSAccessController);

  function IPFSAccessController(ipfs, options) {
    var _this;

    _classCallCheck(this, IPFSAccessController);

    _this = _super.call(this);
    _this._ipfs = ipfs;
    _this._write = Array.from(options.write || []);
    return _this;
  } // Returns the type of the access controller


  _createClass(IPFSAccessController, [{
    key: "write",
    get: // Return a Set of keys that have `access` capability
    function get() {
      return this._write;
    }
  }, {
    key: "canAppend",
    value: function () {
      var _canAppend = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(entry, identityProvider) {
        var key;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                // Allow if access list contain the writer's publicKey or is '*'
                key = entry.identity.id;

                if (!(this.write.includes(key) || this.write.includes('*'))) {
                  _context.next = 3;
                  break;
                }

                return _context.abrupt("return", identityProvider.verifyIdentity(entry.identity));

              case 3:
                return _context.abrupt("return", false);

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function canAppend(_x, _x2) {
        return _canAppend.apply(this, arguments);
      }

      return canAppend;
    }()
  }, {
    key: "load",
    value: function () {
      var _load = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(address) {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                // Transform '/ipfs/QmPFtHi3cmfZerxtH9ySLdzpg1yFhocYDZgEZywdUXHxFU'
                // to 'QmPFtHi3cmfZerxtH9ySLdzpg1yFhocYDZgEZywdUXHxFU'
                if (address.indexOf('/ipfs') === 0) {
                  address = address.split('/')[2];
                }

                _context2.prev = 1;
                _context2.next = 4;
                return io.read(this._ipfs, address);

              case 4:
                this._write = _context2.sent;
                _context2.next = 10;
                break;

              case 7:
                _context2.prev = 7;
                _context2.t0 = _context2["catch"](1);
                console.log('IPFSAccessController.load ERROR:', _context2.t0);

              case 10:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this, [[1, 7]]);
      }));

      function load(_x3) {
        return _load.apply(this, arguments);
      }

      return load;
    }()
  }, {
    key: "save",
    value: function () {
      var _save = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        var cid;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.prev = 0;
                _context3.next = 3;
                return io.write(this._ipfs, 'dag-cbor', {
                  write: JSON.stringify(this.write, null, 2)
                });

              case 3:
                cid = _context3.sent;
                _context3.next = 9;
                break;

              case 6:
                _context3.prev = 6;
                _context3.t0 = _context3["catch"](0);
                console.log('IPFSAccessController.save ERROR:', _context3.t0);

              case 9:
                return _context3.abrupt("return", {
                  address: cid
                });

              case 10:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this, [[0, 6]]);
      }));

      function save() {
        return _save.apply(this, arguments);
      }

      return save;
    }()
  }], [{
    key: "type",
    get: function get() {
      return type;
    }
  }, {
    key: "create",
    value: function () {
      var _create = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(orbitdb) {
        var options,
            _args4 = arguments;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                options = _args4.length > 1 && _args4[1] !== undefined ? _args4[1] : {};
                options = _objectSpread(_objectSpread({}, options), {
                  write: options.write || [orbitdb.identity.id]
                });
                return _context4.abrupt("return", new IPFSAccessController(orbitdb._ipfs, options));

              case 3:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }));

      function create(_x4) {
        return _create.apply(this, arguments);
      }

      return create;
    }()
  }]);

  return IPFSAccessController;
}(AccessController);

module.exports = IPFSAccessController;